export default "__VITE_ASSET__bMU59kv8__"